import { useState, useEffect } from 'react'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import {
    Box, Grid, Stack, Paper, Typography, Button, FormControlLabel,
    TextField, Checkbox, Tooltip, Autocomplete,
    Divider
} from '@mui/material';
import { ImagePaths } from '../../../Utility/ImagePaths';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { Asset_Layout_Default_JSON } from '../../../Utility/Constants';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import { Colors } from '../../../Styles/Colors';
import Loader from '../../../Components/Loader';

const fontSizeList = [7, 8, 9, 10, 11, 12];
const fontList = [
    { label: "Arial", value: "Arial" },
    { label: "Times New Roman", value: "TimesNewRoman" },
    { label: "Calibri", value: "Calibri" },
    { label: "Verdana", value: "Verdana" },
    { label: "Helvetica", value: "Helvetica" }
]

const maxLimits = {
    cardWidth: 10,
    cardHeight: 10,
    marginTop: 1.5,
    marginBottom: 1.5,
    marginLeft: 1.5,
    marginRight: 1.5,
};

const findValue = (list = [], value) => {
    return list?.find(item => item.value === value) || null;
}

const horizontalList = [
    { value: "left", title: "Align Left", img: ImagePaths.AlignLeft.default, disImg: ImagePaths.DisAlignLeft.default },
    { value: "center", title: "Align Center", img: ImagePaths.AlignCenter.default, disImg: ImagePaths.DisAlignCenter.default },
    { value: "right", title: "Align Right", img: ImagePaths.AlignRight.default, disImg: ImagePaths.DisAlignRight.default },
]
const verticalList = [
    { value: "top", title: "Align Top", img: ImagePaths.AlignTop.default, disImg: ImagePaths.DisAlignTop.default },
    { value: "middle", title: "Align Middle", img: ImagePaths.AlignMiddle.default, disImg: ImagePaths.DisAlignMiddle.default },
    { value: "bottom", title: "Align Bottom", img: ImagePaths.AlignBottom.default, disImg: ImagePaths.DisAlignBottom.default },
]

const AssetPrintConfiguration = () => {
    const [state, setState] = useState({
        previewUrl: "",
        cardWidth: "8",
        cardHeight: "8",
        marginTop: "0.1",
        marginBottom: "0.1",
        marginLeft: "0.1",
        marginRight: "0.1",
        fontSize: 7,
        font: "Helvetica",
        card_detail_data: JSON.parse(JSON.stringify(Asset_Layout_Default_JSON)),
        horizontal_aligment: "center",
        vertical_aligment: "middle",
        is_state_updated: false,
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: '',
        isLoader: false,
    });

    useEffect(() => {
        getLabelLayoutDetails()
    }, [])

    useEffect(() => {
        if (state.is_state_updated) {
            getCustomCardPreview()
        }
    }, [state.is_state_updated])

    const updateState = (data) => {
        setState((prev) => ({
            ...prev,
            ...data
        }))
    }

    const LoaderFunction = (key) => {
        updateState({
            isLoader: key
        })
    }

    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const successMessage = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message
        })
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const getLabelLayoutDetails = () => {
        try {
            LoaderFunction(true)
            RestAPIService.getAllTwo(Serviceurls.ASSET_PRINT_LAYOUT_CONFIG)
                .then((response) => {
                    if (response.data.status === "success") {
                        const Data = response.data.data
                        updateState({
                            cardWidth: Data?.barcode_details?.width || 8,
                            cardHeight: Data?.barcode_details?.height || 8,
                            fontSize: Data?.barcode_details?.font_size || 7,
                            font: Data?.barcode_details?.font_name || "Helvetica",
                            marginTop: Data?.margin_setup?.top || "0.1",
                            marginBottom: Data?.margin_setup?.bottom || "0.1",
                            marginLeft: Data?.margin_setup?.left || "0.1",
                            marginRight: Data?.margin_setup?.right || "0.1",
                            card_detail_data: Data?.asset_details || JSON.parse(JSON.stringify(Asset_Layout_Default_JSON)),
                            horizontal_aligment: Data?.content_alignment?.horizontal || "center",
                            vertical_aligment: Data?.content_alignment?.vertical || "top",
                            is_state_updated: true,
                        })
                    }
                }).catch((error) => {
                    LoaderFunction(false)
                    errorMessage(error.response.data.message || error.message)
                })
        } catch (e) {
            LoaderFunction(false)
            errorMessage(e.message)
        }
    }

    const getCustomCardPreview = () => {
        try {
            RestAPIService.getAll(`${Serviceurls.ASSET_LIST_BAR_CODE}?preview=true`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    updateState({ previewUrl: fileURL, is_state_updated: false })
                    LoaderFunction(false);
                }).catch((e) => {
                    errorMessage(e.message)
                    LoaderFunction(false);
                })
        }
        catch (e) {
            errorMessage(e.message)
            LoaderFunction(false);
        }
    }

    const resetCardDetails = () => {
        try {
            updateState({
                cardWidth: "8",
                cardHeight: "8",
                marginTop: "0.1",
                marginBottom: "0.1",
                marginLeft: "0.1",
                marginRight: "0.1",
                fontSize: 7,
                font: "Helvetica",
                card_detail_data: JSON.parse(JSON.stringify(Asset_Layout_Default_JSON)),
                horizontal_aligment: "center",
                vertical_aligment: "middle",
                is_state_updated: false,
            })
        } catch (e) {
            LoaderFunction(false)
            errorMessage(e.message)
        }
    }

    const checkValidation = () => {
        const cardDetails = state?.card_detail_data.every(obj => !obj.is_active);

        if (state?.cardWidth < 8) {
            errorMessage("Card width should be Greater than or Equal to 8")
            return false
        } else if (state?.cardHeight < 8) {
            errorMessage("Card height should be Greater than or Equal to 8")
            return false
        } else if (cardDetails) {
            errorMessage("Asset details should not be empty")
            return false
        } else {
            return true
        }
    }

    const postCardDetails = () => {
        try {
            let validation = checkValidation()
            if (validation) {
                LoaderFunction(true)
                const data = {
                    "barcode_details": {
                        "height": +state.cardHeight || 8,
                        "width": +state.cardWidth || 8,
                        "font_size": +state.fontSize || 7,
                        "font_name": state.font || "Helvetica",
                    },
                    "margin_setup": {
                        "top": +state.marginTop || 0.1,
                        "bottom": +state.marginBottom || 0.1,
                        "left": +state.marginLeft || 0.1,
                        "right": +state.marginRight || 0.1,
                    },
                    "asset_details": state?.card_detail_data,
                    "content_alignment": {
                        "vertical": state.vertical_aligment || "middle",
                        "horizontal": state.horizontal_aligment || "center",
                    },
                }
                RestAPIService.create(data, Serviceurls.ASSET_PRINT_LAYOUT_CONFIG)
                    .then((response) => {
                        if (response.data.status === "success") {
                            LoaderFunction(false)
                            successMessage(response.data.message)
                            getLabelLayoutDetails()
                        }
                    }).catch((error) => {
                        LoaderFunction(false)
                        errorMessage(error?.response?.data?.message || error?.message)
                    })
            }
        } catch (e) {
            LoaderFunction(false)
            errorMessage(e.message)
        }
    }

    const renderCardLeft = () => {
        try {
            return (
                <Paper className='eMed_iplabel_layout' elevation={2}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", overflowY: "auto" }}>
                        {state.previewUrl ? <iframe
                            style={{ width: "100%", height: "100%" }}
                            src={state.previewUrl}
                            type="application/pdf" />
                            : <Typography fontSize={"1vw"} textAlign={"center"}>No preview available</Typography>}
                    </Box>
                </Paper>
            )
        } catch (e) { errorMessage(e.message) }
    }

    const onChangeHandler = (value, stateKey) => {
        try {
            const max = maxLimits[stateKey];
            let isValid = false;
            if (stateKey === "row" || stateKey === "column") {
                isValid = (CommonValidation.numberOnly(value) && (!max || value <= max) && +value > 0) || value === "";
            } else {
                isValid = (CommonValidation.DecimalNumber(value) && (!max || value <= max) && value !== "00") || value === "";
            }

            if (isValid || max === undefined) {
                updateState({ [stateKey]: value });
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderTextField = (label, stateKey, fromMargin = false) => {
        return (
            <Box mb={"0.625vw"} display={"flex"} flexDirection={fromMargin ? "row" : "column"} gap={fromMargin ? "0.625vw" : "0"} alignItems={fromMargin ? "center" : "flex-start"}>
                <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"} flex={fromMargin ? "0 0 20%" : "unset"}>{label}</Typography>
                <TextField
                    size='small'
                    sx={{ width: fromMargin ? "10vw" : "100%" }}
                    autoComplete='off'
                    value={state[stateKey]}
                    onChange={(e) => { onChangeHandler(e.target.value, stateKey) }}
                    InputProps={{
                        endAdornment: (stateKey === "row" || stateKey === "column") ? null : <Typography>cm</Typography>,
                        emed_tid: `Field_${stateKey}`
                    }}
                />
            </Box>
        )
    }

    const renderAutoComplete = (label, statekey, list = [], showKey = "label", valueKey = "value") => {
        return (
            <Box mb={"0.625vw"}>
                {label && <Typography fontWeight={600} fontSize={"0.8vw"} mb={"0.3vw"}>{label}</Typography>}
                <Autocomplete
                    size="small"
                    options={list || []}
                    getOptionLabel={(option) => (typeof option === "string" ? option : option?.[showKey] ? option[showKey] || "" : JSON.stringify(option))}
                    value={statekey === "fontSize" ? state[statekey] : findValue(list, state[statekey]) || null}
                    disableClearable
                    onChange={(event, newValue) => {
                        onChangeHandler(statekey === "fontSize" ? newValue : newValue[valueKey], statekey)
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            sx={{ width: "100%" }}
                            size='small'
                            autoComplete="off"
                            inputProps={{
                                ...params.inputProps,
                            }}
                        />
                    )}
                />
            </Box>
        );
    };

    const handleDrag = (e) => { updateState({ drag_label: e.currentTarget.id }) }

    const handleDrop = (e) => {
        e.preventDefault();

        const dragLabel = state.drag_label;
        const dropLabel = e.currentTarget.id;

        if (!dragLabel || dragLabel === dropLabel) return;

        const items = [...state.card_detail_data];

        const dragIndex = items.findIndex((f) => f.label === dragLabel);
        const dropIndex = items.findIndex((f) => f.label === dropLabel);

        if (dragIndex === -1 || dropIndex === -1) return;

        const dragItem = { ...items[dragIndex] };
        const dropItem = { ...items[dropIndex] };

        const tempId = dragItem.id;
        dragItem.id = dropItem.id;
        dropItem.id = tempId;

        items[dragIndex] = dropItem;
        items[dropIndex] = dragItem;

        updateState({ card_detail_data: items });
    };

    const handleCheckClick = (e) => {
        let { card_detail_data } = state

        const ID = e?.target?.id

        if (ID) {
            const Index = card_detail_data.findIndex((data) => {
                return data.id == ID
            })

            if (!card_detail_data[Index].is_default) {
                card_detail_data[Index].is_active = e.target.checked
            }

            updateState({ card_detail_data })
        } else {
            card_detail_data.forEach((item) => {
                const Index = card_detail_data.findIndex((data) => {
                    return data.id == item.id
                })

                if (!card_detail_data[Index].is_default) {
                    card_detail_data[Index].is_active = true
                }

                updateState({ card_detail_data })
            })
        }
    }

    const renderCardField = (data) => {
        return (
            data?.label === "Barcode" ?
                <div
                    draggable={false}
                    id={data.label}
                    className="eMed_demolayout_right2_field">
                    <FormControlLabel control={<Checkbox id={data.id} emed_tid="Card_Details_CheckBox" onChange={handleCheckClick} checked={data.is_active} />} label={data.label} />
                </div> :
                <div
                    draggable={true}
                    onDragOver={(e) => e.preventDefault()}
                    onDragStart={handleDrag}
                    onDrop={handleDrop}
                    id={data.label}
                    className="eMed_demolayout_right2_field">
                    <img className="eMed_demolayout_right2_field_img" src={ImagePaths.DragIndicator.default} alt="Drag Here" />
                    <FormControlLabel control={<Checkbox id={data.id} disabled={data?.label === "IP Admission Id"} emed_tid="Card_Details_CheckBox" onChange={handleCheckClick} checked={data.is_active} />} label={data.label} />
                </div>
        )
    }

    const renderContentAlignment = (list, stateKey) => {
        return (
            <Stack direction="row" spacing={1} alignItems="flex-end" mt="0.5vw">
                {list.map(({ value, title, img, disImg }) => (
                    <Tooltip key={title} placement="top" title={title}>
                        <Button
                            sx={{
                                minWidth: "unset",
                                width: "3.8dvw !important",
                                height: "2.5dvw !important",
                                p: 0, display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                            emed_tid={`${value}_align_button`}
                            onClick={() => updateState({ [stateKey]: value })}
                            variant={state[stateKey] === value ? "contained" : "outlined"}
                        >
                            <img
                                style={{ width: "1.3vw", height: "2vw" }}
                                src={state[stateKey] === value ? img : disImg}
                                alt={title}
                            />
                        </Button>
                    </Tooltip>
                ))}
            </Stack>)
    }

    const renderCardRight = () => {
        try {
            return (
                <Paper className='eMed_iplabel_layout' elevation={2}>
                    <Typography className='eMed_refdoc_title'>Asset Barcode Layout Configuration</Typography>
                    <Box sx={{ height: "64.5vh", overflowY: "auto" }}>
                        <Box className="eMed_ipLabel_right_divs">
                            <Typography sx={{ fontWeight: "600" }}>Card Layout Field</Typography>
                            <Typography sx={{ fontSize: "0.8vw" }}>(Switch the fields according to your practice)</Typography>
                        </Box>
                        <Box className="eMed_ipLabel_right_divs">
                            <Typography sx={{ fontWeight: "600", fontSize: "1vw" }}>Barcode Details</Typography>
                            <Box className='eMed_ipLabel_grid_container'>
                                {renderTextField("Width", "cardWidth")}
                                {renderTextField("Height", "cardHeight")}
                            </Box>
                            <Box className='eMed_ipLabel_grid_container'>
                                {renderAutoComplete("Font Size", "fontSize", fontSizeList)}
                                {renderAutoComplete("Font Style", "font", fontList)}
                            </Box>
                        </Box>
                        <Box className="eMed_ipLabel_right_divs">
                            <Typography sx={{ fontWeight: "600", fontSize: "1vw" }}>Margin Setup</Typography>
                            <Typography fontSize={"0.8vw"} mb={"0.3vw"} color={"#8a8585"}>Settings</Typography>
                            {renderTextField("Top", "marginTop", true)}
                            {renderTextField("Bottom", "marginBottom", true)}
                            {renderTextField("Left", "marginLeft", true)}
                            {renderTextField("Right", "marginRight", true)}
                        </Box>
                        <Box className="eMed_ipLabel_right_divs">
                            <Typography sx={{ fontWeight: "600", fontSize: "1vw" }}>Asset Details</Typography>
                            {state.card_detail_data.map((item) => { return (renderCardField(item)) })}
                        </Box>
                        <Box className="eMed_ipLabel_right_divs">
                            <Typography sx={{ fontWeight: "600", fontSize: "1vw" }}>Content Alignment</Typography>
                            <Typography fontSize={"0.8vw"} mb={"0.3vw"} color={"#8a8585"}>( Switch the fields according to your practice )</Typography>
                            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} gap={"0.625vw"}>
                                {renderContentAlignment(horizontalList, "horizontal_aligment")}
                                <Divider orientation="vertical" sx={{
                                    borderRightWidth: "3px",
                                    height: "2.5dvw",
                                    alignSelf: "center",
                                    mx: "0.5vw"
                                }} />
                                {renderContentAlignment(verticalList, "vertical_aligment")}
                            </Box>
                        </Box>
                    </Box>
                    <Stack className='eMed_DisSum_right_Btn' spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"}>
                        <Button emed_tid={'Reset_Button'} disabled={state?.isLoader} variant='outlined' size="small" id="eMed_Config_btn" onClick={resetCardDetails}>{"Reset"}</Button>
                        <Button emed_tid={'Post_Button'}
                            disabled={state?.isLoader}
                            variant='contained' size="small" id="eMed_Config_btn"
                            onClick={postCardDetails}>{"Save"}</Button>
                    </Stack>
                </Paper>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <Box sx={{ padding: "0.625vw", backgroundColor: Colors.configHomeBg }}>
            <Grid container spacing={1} className="eMed_srvConfig_Box">
                <Grid item xs={8} sx={{ height: "78vh" }}> {renderCardLeft()} </Grid>
                <Grid item xs={4} sx={{ height: "78vh" }}> {renderCardRight()} </Grid>
            </Grid>
            {state.isErrorMsg && <ToastMsg severity={'error'} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {state.successMsg && <ToastMsg severity={'success'} msg={state.successMsgText} msgPop={msgClose.bind(this)} />}
            <Loader loaderOpen={state.isLoader} />
        </Box>
    )
}

export default AssetPrintConfiguration;